// 'use client';

import React, { memo, useEffect, useState } from 'react';
import { t } from 'ttag';

function Cart() {
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const getCartCount = async () => {
      const response = await fetch('/cart/items/count/');

      if (!response.ok) {
        return 0;
      }

      const { count } = await response.json();

      return count;
    };

    getCartCount().then(setCartCount);
  }, []);

  return (
    <a
      href="/cart/summary/"
      className="relative block flex items-center p-3 text-black outline-none focus:outline-none"
      aria-label={t`Go to your cart`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0"
      >
        <circle cx="8" cy="21" r="1" />
        <circle cx="19" cy="21" r="1" />
        <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
      </svg>
      {cartCount > 0 && (
        <span className="absolute bottom-0 right-0 flex h-4 w-4 items-center justify-center rounded-full bg-black text-[8px] leading-none leading-none text-white">
          {cartCount}
        </span>
      )}
    </a>
  );
}

export default memo(Cart);
